import { AppCacheKeys } from 'src/types';
import { Application } from '../../features/common/types';

export const journeyName = {
  BUY_POS: 'buy pos',
  THIRD_PARTY: 'third party',
  TAP_ON_PHONE: 'tap on phone onboarding',
  DEVICE_ACTIVATION: 'register device',
  PENDING_APPLICATION: 'pending application',
  CONTINUE_APPLICATION: 'continue application',
  ONBOARDING: 'onboarding',
} as const;

export const getJourneyNameFromSessionStorage = () => {
  const onboarding = JSON.parse(sessionStorage.getItem('onboarding') || '');

  const selfOnboarding: Application = onboarding[AppCacheKeys.selfOnboarding]?.item;
  const thirdParty: Application = onboarding[AppCacheKeys.thirdParty]?.item;
  const deviceActivation: Application = onboarding[AppCacheKeys.deviceActivation]?.item;

  const isPOSRevamp = !!(
    selfOnboarding &&
    !selfOnboarding.brokerLogin &&
    !selfOnboarding.agentJourney &&
    !selfOnboarding.pendingApp?.isPending
  );
  const is3rdParty = !!(thirdParty && (thirdParty.brokerLogin || thirdParty.agentJourney));
  const isDeviceActivation = !!(deviceActivation && deviceActivation.deviceActivationJourney);
  const isContinueWithOTP =
    selfOnboarding?.isContinueWithOTP ||
    thirdParty?.isContinueWithOTP ||
    deviceActivation?.isContinueWithOTP;
  const isPendingApplication = !!(selfOnboarding && selfOnboarding.pendingApp?.isPending);
  const isOnboarding = !!(
    (selfOnboarding && !selfOnboarding.pendingApp?.isPending) ||
    (thirdParty && !thirdParty.pendingApp?.isPending) ||
    (deviceActivation && !deviceActivation.pendingApp?.isPending)
  );

  switch (true) {
    case isPendingApplication:
      return journeyName.PENDING_APPLICATION;
    case isContinueWithOTP:
      return journeyName.CONTINUE_APPLICATION;
    case isPOSRevamp:
      return journeyName.BUY_POS;
    case is3rdParty:
      return journeyName.THIRD_PARTY;
    case isDeviceActivation:
      return journeyName.DEVICE_ACTIVATION;
    case isOnboarding:
      return journeyName.ONBOARDING;
  }
};
